import { themeColor } from '@config/theme';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ChatNotSelectedWindowProps {
	successBackground: string;
}

export const ChatNotSelectedWindow: React.FC<ChatNotSelectedWindowProps> = ({
	successBackground,
}) => {
	const { t } = useTranslation();

	const styles = {
		container: {
			flex: 1,
			minWidth: '200px',
			display: window.innerWidth > 600 ? 'flex' : 'none',
			flexDirection: 'column' as const,
			justifyContent: 'center',
			alignItems: 'center',
			height: '100%',
			gap: '24px',
			backgroundImage: `url(${successBackground})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
			overflowY: 'auto' as const,
		},
		title: {
			color: themeColor.darkGray,
			textAlign: 'center' as const,
			fontSize: '20px',
			fontWeight: 700,
			textTransform: 'capitalize' as const,
		},
		message: {
			textAlign: 'center' as const,
			fontSize: '16px',
			fontWeight: 400,
			maxWidth: '340px',
			color: themeColor.gray,
		},
		button: {
			marginTop: '24px',
		},
	};

	const isChatEmpty = false;

	return (
		<Box sx={styles.container}>
			<Typography variant="h4" sx={styles.title}>
				{isChatEmpty ? t('chats.getReadyToChat') : t('chats.noChatSelected')}
			</Typography>
			<Typography variant="h6" sx={styles.message}>
				{isChatEmpty ? t('chats.getReadyToChatMessage') : t('chats.noChatSelectedMessage')}
			</Typography>
			{isChatEmpty && (
				<Button variant="contained" sx={styles.button}>
					{t('chats.findSpecialistButton')}
				</Button>
			)}
		</Box>
	);
};
